<!-- Add Customer Dialog -->
  <p-dialog [(visible)]="displayAddDialog" header="Add New Customer" [modal]="true" [style]="{width: '800px'}"
    styleClass="customer-dialog" [draggable]="false" (onHide)="closeDialog()">
    <ng-template pTemplate="header">
      <div class="flex justify-content-center align-items-center w-full">
        <span class="text-xl font-bold">Add New Customer</span>
      </div>
    </ng-template>
    <div class="flex flex-column gap-3">
      <!-- Top Row: Customer Details and Service Hours -->
      <div class="flex gap-3">
        <!-- Customer Details -->
        <div class="flex-1 surface-section p-3 border-round-lg shadow-1" 
             style="background-color: var(--surface-card);">
          <div class="text-lg font-semibold text-900 mb-3">
            <i class="pi pi-building mr-2"></i>
            Customer Details
          </div>
          <div class="flex flex-column gap-3">
            <span class="p-float-label w-full">
              <input pInputText id="name" [(ngModel)]="newCustomer.name" class="w-full" />
              <label for="name">Customer Name*</label>
            </span>
            <span class="p-float-label w-full">
              <p-dropdown id="customer_type" 
                [options]="customerTypeOptions" 
                [(ngModel)]="newCustomer.customer_type"
                optionLabel="label" 
                optionValue="value"
                class="w-full"
                styleClass="w-full"
                placeholder="Select Customer Type"
                (onChange)="onCustomerTypeChange()">
              </p-dropdown>
              <label for="customer_type">Customer Type*</label>
            </span>
          </div>
        </div>

        <!-- Service Hours -->
        <div class="flex-1 surface-section p-3 border-round-lg shadow-1" 
             style="background-color: var(--surface-card);">
          <div class="text-lg font-semibold text-900 mb-3">
            <i class="pi pi-clock mr-2"></i>
            Service Hours
          </div>
          <div class="flex gap-2">
            <div class="flex-1">
              <label for="service_hours_start" class="block text-sm font-medium mb-2">Start</label>
              <input type="time" pInputText id="service_hours_start" [(ngModel)]="newCustomer.service_hours_start" class="w-full" />
            </div>
            <div class="flex-1">
              <label for="service_hours_end" class="block text-sm font-medium mb-2">End</label>
              <input type="time" pInputText id="service_hours_end" [(ngModel)]="newCustomer.service_hours_end" class="w-full" />
            </div>
          </div>
        </div>
      </div>

      <!-- Address Information -->
      <div class="surface-section p-3 border-round-lg shadow-1" 
           style="background-color: var(--surface-card);">
        <div class="text-lg font-semibold text-900 mb-5">
          <i class="pi pi-map-marker mr-2"></i>
          Address Information
        </div>
        <div class="flex flex-column gap-3">
          <span class="p-float-label w-full">
            <textarea pInputTextarea id="address" [(ngModel)]="newCustomer.address" [rows]="1"
              class="w-full"></textarea>
            <label for="address">Street Address</label>
          </span>
          <div class="flex gap-3">
            <span class="p-float-label flex-1">
              <input pInputText id="city" [(ngModel)]="newCustomer.city" class="w-full" />
              <label for="city">City</label>
            </span>
            <span class="p-float-label" style="width: 100px;">
              <input pInputText id="state" [(ngModel)]="newCustomer.state" class="w-full" />
              <label for="state">State</label>
            </span>
            <span class="p-float-label" style="width: 120px;">
              <input pInputText id="zip" [(ngModel)]="newCustomer.zipcode" class="w-full" />
              <label for="zip">ZIP Code</label>
            </span>
          </div>
          <span class="p-float-label w-full">
            <textarea pInputTextarea id="address_notes" [(ngModel)]="newCustomer.notes" [rows]="1"
              class="w-full"></textarea>
            <label for="address_notes">Address Notes</label>
          </span>
        </div>
      </div>

      <!-- Contact Information Section -->
      <div class="surface-section p-3 border-round-lg shadow-1" 
           style="background-color: var(--surface-card);">
        <div class="text-lg font-semibold text-900 mb-3">
          <i class="pi pi-users mr-2 mb-3"></i>
          Contact Information
        </div>
        <div class="flex flex-column gap-3">
          <div class="p-2 border-1 border-200 border-round">
            <div class="flex align-items-center gap-2 mb-2">
              <span class="font-medium text-sm">Primary Contact</span>
            </div>
            
            <div class="flex gap-2">
              <span class="p-float-label flex-1">
                <input pInputText id="contact_name" [(ngModel)]="newCustomer.contact_person" class="w-full" />
                <label for="contact_name">Name</label>
              </span>
              <span class="p-float-label flex-1">
                <input pInputText id="contact_email" [(ngModel)]="newCustomer.email" type="email" class="w-full" />
                <label for="contact_email">Email</label>
              </span>
              <span class="p-float-label flex-1">
                <input pInputText id="contact_phone" [(ngModel)]="newCustomer.phone" class="w-full" />
                <label for="contact_phone">Phone</label>
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Customer Relationships Section -->
      <div *ngIf="shouldShowRelationships" class="surface-section p-3 border-round-lg shadow-1" 
           style="background-color: var(--surface-card);">
        <div class="text-lg font-semibold text-900 mb-5">
          <i class="pi pi-link mr-2"></i>
          Customer Relationships
        </div>
        <div class="flex gap-3">
          <!-- Supplies To (Delivers To) -->
          <div *ngIf="newCustomer.customer_type === 'Supplier' || newCustomer.customer_type === 'Both'" class="flex-1">
            <span class="p-float-label w-full">
              <p-multiSelect 
                id="supplies_to" 
                [options]="availableReceiversForRelationship"
                [(ngModel)]="newCustomer.delivers_to"
                optionLabel="name"
                optionValue="customer_id"
                placeholder="Select customers this supplier delivers to"
                [filter]="true"
                filterBy="name"
                [showToggleAll]="false"
                class="w-full">
              </p-multiSelect>
              <label for="supplies_to">Supplies To</label>
            </span>
          </div>
          
          <!-- Receives From -->
          <div *ngIf="newCustomer.customer_type === 'Receiver' || newCustomer.customer_type === 'Both'" class="flex-1">
            <span class="p-float-label w-full">
              <p-multiSelect 
                id="receives_from" 
                [options]="availableSuppliersForRelationship"
                [(ngModel)]="newCustomer.receives_from"
                optionLabel="name"
                optionValue="customer_id"
                placeholder="Select customers this receiver gets deliveries from"
                [filter]="true"
                filterBy="name"
                [showToggleAll]="false"
                class="w-full">
              </p-multiSelect>
              <label for="receives_from">Receives From</label>
            </span>
          </div>
        </div>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <div class="flex justify-content-end gap-2">
        <button pButton label="Cancel" (click)="closeDialog()" class="p-button-outlined"></button>
        <button pButton label="Save Customer"
          icon="pi pi-check"
          (click)="saveNewCustomer()"
          [disabled]="!newCustomer.name || !newCustomer.customer_type || saving"
          [loading]="saving">
        </button>
      </div>
    </ng-template>
  </p-dialog>
